import { Link } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { getColumns } from "../columns";
import { fShortMonthDayYearSlashNotation } from "../../utils/formatTime";
import { DeadCheckInfo, deadCheckReasons } from "./types";

const checkColumns = new Set(["Date", "Ledger Name", "Department", "Amount", "Payee", "Trust Account", "Check #"]);

export const columns: MRT_ColumnDef<DeadCheckInfo>[] = [
  ...(getColumns(new Set()).filter((column) => checkColumns.has(column.header)) as MRT_ColumnDef<DeadCheckInfo>[]),
  { header: "Reason", id: "reason", accessorFn: (row) => row.deadCheck ? deadCheckReasons[row.deadCheck.reason] : "", filterVariant: "select" },
  {
    header: "Last Activity",
    id: "lastActivity",
    accessorFn: (row) => row.deadCheck?.dateOfLastActivity?.slice(0, 10) || "",
    Cell: ({ row }) => row.original.deadCheck ? fShortMonthDayYearSlashNotation(row.original.deadCheck.dateOfLastActivity) : ""
  },
  { header: "Payee State", id: "payeeState", accessorFn: (row) => row.deadCheck?.state || "Unknown", filterVariant: "select" },
  { header: "Street", id: "street", accessorFn: (row) => row.deadCheck?.street || "" },
  { header: "Apt", id: "apt", accessorFn: (row) => row.deadCheck?.apt || "" },
  { header: "City", id: "city", accessorFn: (row) => row.deadCheck?.city || "" },
  { header: "Zip", id: "zip", accessorFn: (row) => row.deadCheck?.zip || "" },
  {
    header: "Tax ID Document URL",
    id: "taxIdDocumentUrl",
    accessorFn: (row) => row.deadCheck?.taxIdDocumentUrl || "",
    Cell: ({ row }) => row.original.deadCheck?.taxIdDocumentUrl && (
      <Link href={row.original.deadCheck.taxIdDocumentUrl} target="_blank" rel="noopener noreferrer">View document</Link>
    )
  },
  { header: "Contact Email", id: "contactEmail", accessorFn: (row) => row.deadCheck?.contactEmail || "" },
  { header: "Contact Phone", id: "contactPhone", accessorFn: (row) => row.deadCheck?.contactPhone || "" },
  {
    header: "Marked Dead",
    id: "markedDead",
    accessorFn: (row) => row.deadCheck?.dateCreated || "",
    Cell: ({ row }) => row.original.deadCheck ? fShortMonthDayYearSlashNotation(row.original.deadCheck.dateCreated) : ""
  },
  { header: "Marked By", id: "createdByUserEmail", accessorFn: (row) => row.deadCheck?.createdByUserEmail || "" }
];
